/**
 * Application environment mode (from VITE_APP_ENV_MODE).
 * Used to branch behaviour for localhost, development, staging, and production.
 */
export enum AppEnvModeEnum {
  Localhost = 'localhost',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
